(function () {
  "use strict";

  var config = window.SHOPASSIST_CONFIG || {};
  var API_BASE_URL = config.apiBaseUrl || "http://localhost:8001";
  var API_KEY = config.apiKey || "";
  // A bare "prunex-mark.png" resolves against the *host page's* URL, not
  // this script's, so it 404s on any real third-party storefront.
  // Configurable; omitted entirely (no broken-image icon) if unset.
  var LOGO_URL = config.logoUrl || "https://prunex.ai/resources/images/logo.png";
  // "fastapi" talks to fast_app.py's POST /api/chat (JSON in, JSON out).
  // "gradio" talks directly to a deployed Gradio Space's queue API (e.g.
  // app.py on Hugging Face Spaces) — no separate backend needed, but it's a
  // different wire protocol, so it's a distinct code path below.
  var BACKEND = config.backend || "fastapi";
  // Only relevant for backend: "gradio". Identifies the respond() event
  // handler inside app.py's Gradio Blocks graph. Found by opening the
  // Space's own page, opening devtools Network tab, sending a message, and
  // reading "fn_index" from the /gradio_api/queue/join request payload. It
  // only changes if app.py's UI structure changes (components/handlers
  // added before the ChatInterface) — redeploying as-is keeps this stable.
  var GRADIO_FN_INDEX = config.gradioFnIndex != null ? config.gradioFnIndex : 6;
  var SESSION_KEY = "shopassist_session_id";
  var REQUEST_TIMEOUT_MS = 30000;

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function stripTrailingPunctuation(url) {
    var trailing = "";
    while (url.length > 0 && /[).,!?;:'"]/.test(url[url.length - 1])) {
      trailing = url[url.length - 1] + trailing;
      url = url.slice(0, -1);
    }
    return { url: url, trailing: trailing };
  }

  function linkTag(url, text) {
    return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + text + "</a>";
  }

  // Turns [text](url) and bare https?:// URLs into real links. Only ever
  // builds an <a> from a URL matching the http(s) scheme regex below, so
  // scraped/LLM text can't smuggle in a javascript: or data: URI.
  function inlineFormat(str) {
    var extractedLinks = [];

    str = str.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (match, text, url) {
      var trimmed = stripTrailingPunctuation(url);
      var token = " LINK" + extractedLinks.length + " ";
      extractedLinks.push(linkTag(trimmed.url, text) + trimmed.trailing);
      return token;
    });

    str = str.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\*(.+?)\*/g, "<em>$1</em>");

    str = str.replace(/(https?:\/\/[^\s<]+)/g, function (match) {
      var trimmed = stripTrailingPunctuation(match);
      return linkTag(trimmed.url, trimmed.url) + trimmed.trailing;
    });

    str = str.replace(/ LINK(\d+) /g, function (match, idx) {
      return extractedLinks[Number(idx)];
    });

    return str;
  }

  // Minimal, safe Markdown -> HTML: escapes first, then only ever inserts a
  // small fixed set of tags via regex, so there is no way for scraped/LLM
  // content to inject arbitrary HTML.
  function renderMarkdown(text) {
    var escaped = escapeHtml(text);
    var lines = escaped.split("\n");
    var html = "";
    var listType = null; // 'ul' | 'ol' | null

    function closeList() {
      if (listType) {
        html += "</" + listType + ">";
        listType = null;
      }
    }

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();

      if (line === "") {
        closeList();
        continue;
      }
      if (/^---+$/.test(line)) {
        closeList();
        html += "<hr>";
        continue;
      }

      var bulletMatch = line.match(/^[-*]\s+(.*)/);
      var numberedMatch = line.match(/^\d+\.\s+(.*)/);

      if (bulletMatch) {
        if (listType !== "ul") {
          closeList();
          html += "<ul>";
          listType = "ul";
        }
        html += "<li>" + inlineFormat(bulletMatch[1]) + "</li>";
        continue;
      }
      if (numberedMatch) {
        if (listType !== "ol") {
          closeList();
          html += "<ol>";
          listType = "ol";
        }
        html += "<li>" + inlineFormat(numberedMatch[1]) + "</li>";
        continue;
      }

      closeList();
      html += "<p>" + inlineFormat(line) + "</p>";
    }
    closeList();
    return html;
  }

  // Inline SVGs (stroke = currentColor) so the widget needs no icon assets and
  // stays crisp at any size / color.
  var ICON_CHAT =
    '<svg class="shopassist-launcher-icon shopassist-launcher-icon--chat" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.9-.9L3 21l1.9-5.6A8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5z"/></svg>';
  var ICON_CHEVRON_DOWN =
    '<svg class="shopassist-launcher-icon shopassist-launcher-icon--close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON_MINIMIZE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON_AVATAR =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z"/><path d="M18.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z"/></svg>';
  var ICON_SEND =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';

  // Label shown when the launcher expands. Kept in one place so it's easy to
  // re-word or localize.
  var LAUNCHER_LABEL = "Chat with AI Agent";

  function buildWidgetDom() {
    var launcher = document.createElement("button");
    launcher.className = "shopassist-launcher";
    launcher.type = "button";
    launcher.setAttribute("aria-label", "Open chat");
    launcher.setAttribute("aria-expanded", "false");
    launcher.innerHTML =
      '<span class="shopassist-launcher-iconwrap" aria-hidden="true">' +
      ICON_CHAT +
      ICON_CHEVRON_DOWN +
      '<span class="shopassist-launcher-pip"></span>' +
      "</span>" +
      '<span class="shopassist-launcher-label">' +
      LAUNCHER_LABEL +
      "</span>";

    var logoMarkHtml = LOGO_URL
      ? '<img class="shopassist-footer-mark" src="' + escapeHtml(LOGO_URL) + '" alt="" aria-hidden="true" />'
      : "";

    var panel = document.createElement("div");
    panel.className = "shopassist-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-label", "AI Agent chat");
    panel.setAttribute("aria-hidden", "true");
    panel.innerHTML =
      '<div class="shopassist-header">' +
      '<div class="shopassist-avatar" aria-hidden="true">' +
      ICON_AVATAR +
      "</div>" +
      '<div class="shopassist-headtext">' +
      '<span class="shopassist-title">AI Agent</span>' +
      '<span class="shopassist-status">Online now</span>' +
      "</div>" +
      '<button type="button" class="shopassist-min" aria-label="Minimize chat">' +
      ICON_MINIMIZE +
      "</button>" +
      "</div>" +
      '<div class="shopassist-messages" role="log" aria-live="polite"></div>' +
      '<form class="shopassist-input-row">' +
      '<input type="text" class="shopassist-input" placeholder="Ask about products or policies..." aria-label="Message" autocomplete="off" />' +
      '<button type="submit" class="shopassist-send" aria-label="Send message">' +
      ICON_SEND +
      "</button>" +
      "</form>" +
      '<a class="shopassist-footer" href="https://prunex.ai" target="_blank" rel="noopener noreferrer">' +
      "Powered by" +
      logoMarkHtml +
      "<strong>Prunex.ai</strong>" +
      "</a>";

    document.body.appendChild(launcher);
    document.body.appendChild(panel);

    return { launcher: launcher, panel: panel };
  }

  // Pull the Prunex brand typeface (Inter) in once, so the widget matches the
  // brand regardless of what fonts the host page ships.
  function ensureBrandFont() {
    if (document.getElementById("shopassist-font")) return;
    var pre1 = document.createElement("link");
    pre1.rel = "preconnect";
    pre1.href = "https://fonts.googleapis.com";
    var pre2 = document.createElement("link");
    pre2.rel = "preconnect";
    pre2.href = "https://fonts.gstatic.com";
    pre2.crossOrigin = "anonymous";
    var link = document.createElement("link");
    link.id = "shopassist-font";
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap";
    document.head.appendChild(pre1);
    document.head.appendChild(pre2);
    document.head.appendChild(link);
  }

  function initWidget() {
    ensureBrandFont();
    var dom = buildWidgetDom();
    var launcher = dom.launcher;
    var panel = dom.panel;

    var messagesEl = panel.querySelector(".shopassist-messages");
    var formEl = panel.querySelector(".shopassist-input-row");
    var inputEl = panel.querySelector(".shopassist-input");
    var sendBtn = panel.querySelector(".shopassist-send");
    var minBtn = panel.querySelector(".shopassist-min");

    var sessionId = null;
    try {
      sessionId = localStorage.getItem(SESSION_KEY);
    } catch (e) {
      // localStorage can throw in some privacy modes; degrade to no persistence.
    }

    // The FastAPI backend issues a session_id itself on first reply (see
    // below). Gradio's queue API has no such handshake — session_hash is
    // just an opaque client-chosen key — so generate one up front here.
    if (!sessionId && BACKEND === "gradio") {
      sessionId =
        "shopassist-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
      try {
        localStorage.setItem(SESSION_KEY, sessionId);
      } catch (e) {
        // ignore persistence failures
      }
    }

    var sending = false;
    var greeted = false;
    var isOpen = false;

    function addMessage(role, text) {
      var bubble = document.createElement("div");
      bubble.className = "shopassist-msg shopassist-msg-" + role;
      bubble.innerHTML = renderMarkdown(text);
      messagesEl.appendChild(bubble);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return bubble;
    }

    function addTypingIndicator() {
      var bubble = document.createElement("div");
      bubble.className = "shopassist-msg shopassist-msg-assistant shopassist-typing";
      bubble.innerHTML = "<span></span><span></span><span></span>";
      messagesEl.appendChild(bubble);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return bubble;
    }

    function setSending(state) {
      sending = state;
      inputEl.disabled = state;
      sendBtn.disabled = state;
    }

    function openPanel() {
      if (isOpen) return;
      isOpen = true;
      launcher.classList.remove("is-peek");
      panel.classList.add("is-open");
      panel.setAttribute("aria-hidden", "false");
      launcher.classList.add("is-open");
      launcher.setAttribute("aria-expanded", "true");
      launcher.setAttribute("aria-label", "Minimize chat");
      if (!greeted) {
        addMessage(
          "assistant",
          "Hi! 👋 I'm your AI assistant. Ask me anything about our products or store policies."
        );
        greeted = true;
      }
      // Wait for the panel's open transition before focusing, so the viewport
      // doesn't jump on mobile.
      setTimeout(function () {
        inputEl.focus();
      }, 120);
    }

    function closePanel() {
      if (!isOpen) return;
      isOpen = false;
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      launcher.classList.remove("is-open");
      launcher.setAttribute("aria-expanded", "false");
      launcher.setAttribute("aria-label", "Open chat");
      launcher.focus();
    }

    launcher.addEventListener("click", function () {
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });
    minBtn.addEventListener("click", closePanel);

    // Minimize on Escape while the panel is open.
    document.addEventListener("keydown", function (e) {
      if ((e.key === "Escape" || e.key === "Esc") && isOpen) {
        closePanel();
      }
    });

    // One-time auto-peek: the launcher expands to reveal its label for a few
    // seconds on first load, so touch users (who can't hover) still discover
    // what it does. Shown once per browser session, and never over an already
    // open panel. Collapses on hover/interaction so it's never in the way.
    var PEEK_SEEN_KEY = "shopassist_peek_seen";
    function endPeek() {
      launcher.classList.remove("is-peek");
    }
    launcher.addEventListener("mouseenter", endPeek);
    launcher.addEventListener("focus", endPeek);

    var peekAlreadySeen = false;
    try {
      peekAlreadySeen = sessionStorage.getItem(PEEK_SEEN_KEY) === "1";
    } catch (e) {
      // sessionStorage may be unavailable; just peek this once.
    }
    if (!peekAlreadySeen) {
      setTimeout(function () {
        if (!isOpen) {
          launcher.classList.add("is-peek");
          setTimeout(endPeek, 4200);
        }
        try {
          sessionStorage.setItem(PEEK_SEEN_KEY, "1");
        } catch (e) {
          // ignore persistence failures
        }
      }, 1200);
    }

    // fast_app.py's POST /api/chat: plain JSON in, JSON out, server issues
    // (and echoes back) the session id.
    function sendViaFastApi(message, signal) {
      var headers = { "Content-Type": "application/json" };
      if (API_KEY) {
        headers["X-API-Key"] = API_KEY;
      }

      return fetch(API_BASE_URL + "/api/chat", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ message: message, session_id: sessionId }),
        signal: signal,
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error("Request failed with status " + res.status);
          }
          return res.json();
        })
        .then(function (data) {
          sessionId = data.session_id;
          try {
            localStorage.setItem(SESSION_KEY, sessionId);
          } catch (e) {
            // ignore persistence failures
          }
          return data.reply;
        });
    }

    // A deployed Gradio Space's queue API (e.g. app.py on Hugging Face
    // Spaces): POST a job, then read the streamed result. No separate JSON
    // API backend needed, but it's Gradio's own protocol, not ours — see
    // GRADIO_FN_INDEX above for the one thing that can drift.
    function sendViaGradio(message, signal) {
      var headers = { "Content-Type": "application/json" };
      if (API_KEY) {
        headers["X-API-Key"] = API_KEY;
      }

      return fetch(API_BASE_URL + "/gradio_api/queue/join", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          data: [message, null],
          fn_index: GRADIO_FN_INDEX,
          session_hash: sessionId,
        }),
        signal: signal,
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error("Request failed with status " + res.status);
          }
          return fetch(
            API_BASE_URL + "/gradio_api/queue/data?session_hash=" + encodeURIComponent(sessionId),
            { signal: signal }
          );
        })
        .then(function (streamRes) {
          if (!streamRes.ok || !streamRes.body) {
            throw new Error("Stream request failed with status " + streamRes.status);
          }
          var reader = streamRes.body.getReader();
          var decoder = new TextDecoder();
          var buffer = "";

          function pump() {
            return reader.read().then(function (result) {
              if (result.done) {
                throw new Error("Stream ended without a result");
              }
              buffer += decoder.decode(result.value, { stream: true });
              var chunks = buffer.split("\n\n");
              buffer = chunks.pop();
              for (var i = 0; i < chunks.length; i++) {
                var chunk = chunks[i];
                if (chunk.indexOf("data: ") !== 0) continue;
                var payload = JSON.parse(chunk.slice(6));
                if (payload.msg === "process_completed") {
                  if (!payload.success) {
                    throw new Error("Assistant request failed");
                  }
                  return payload.output.data[0];
                }
              }
              return pump();
            });
          }

          return pump();
        });
    }

    function sendMessage(message) {
      setSending(true);
      addMessage("user", message);
      var typingBubble = addTypingIndicator();

      var controller = new AbortController();
      var timeoutId = setTimeout(function () {
        controller.abort();
      }, REQUEST_TIMEOUT_MS);

      var requestPromise =
        BACKEND === "gradio"
          ? sendViaGradio(message, controller.signal)
          : sendViaFastApi(message, controller.signal);

      requestPromise
        .then(function (replyText) {
          typingBubble.remove();
          addMessage("assistant", replyText);
        })
        .catch(function () {
          typingBubble.remove();
          addMessage("assistant", "Something went wrong — please try again.");
        })
        .finally(function () {
          clearTimeout(timeoutId);
          setSending(false);
          inputEl.focus();
        });
    }

    formEl.addEventListener("submit", function (e) {
      e.preventDefault();
      if (sending) return;
      var message = inputEl.value.trim();
      if (!message) return;
      inputEl.value = "";
      sendMessage(message);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWidget);
  } else {
    initWidget();
  }
})();
